require('./taxAndRents.scss');
const PropTypes = require('prop-types');
const React = require('react');
const {
    Component
} = require('react');
// @components
const Rents = require('components/taxAndRents/rents/rents');
const FiscalDocuments = require('components/taxAndRents/fiscalDocuments/fiscalDocuments');

class TaxAndRents extends Component {
    render () {
        const {
            immAccounts,
            isInactiveAccountsEnabled,
            taxAndRents,
            handleAccountChange,
            postGetDetails,
            immDocuments,
            additionalDocuments,
            requestDocuments,
            callbackDownloadFile,
            callbackDownloadFiscalFile,
            showAutoDates,
            hideBlocks
        } = this.props;
        return (
            <div className="tax-and-rents">
                <FiscalDocuments
                    immDocuments={immDocuments}
                    additionalDocuments={additionalDocuments}
                    immAccounts={immAccounts}
                    maxNumberOfRows={5}
                    requestDocuments={requestDocuments}
                    callbackDownloadFile={callbackDownloadFile}
                    callbackDownloadFiscalFile={callbackDownloadFiscalFile}
                    showAutoDates={showAutoDates}
                />
                { hideBlocks && <div className="tax-and-rents__rents-panel">
                    <Rents
                        immAccounts={immAccounts}
                        isInactiveAccountsEnabled={isInactiveAccountsEnabled}
                        handleAccountChange={handleAccountChange}
                        taxAndRents={taxAndRents}
                        postGetDetails={postGetDetails}
                        maxNumberOfRows={5}
                        showButton={true}
                    />
                </div>
                }
            </div>
        )
    }
}

TaxAndRents.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    handleAccountChange: PropTypes.func.isRequired,
    taxAndRents: PropTypes.object.isRequired,
    postGetDetails: PropTypes.func.isRequired,
    requestDocuments: PropTypes.func.isRequired,
    immDocuments: PropTypes.object.isRequired,
    additionalDocuments: PropTypes.object.isRequired,
    callbackDownloadFile: PropTypes.func.isRequired,
    callbackDownloadFiscalFile: PropTypes.func.isRequired,
    showAutoDates: PropTypes.bool,
    hideBlocks: PropTypes.bool
}

TaxAndRents.defaultProps = {
    hideBlocks: false
};

module.exports = TaxAndRents;
